import { LastViesCreationParams, EhrDataListItem, CustomerDataListItem } from 'chaika-frontend-types/frontend-cms';

import { axios } from '@lib/axios';

const BASE_URL = '/api/last-view';

export class LastViewApi {
    public static async create(lastView: LastViesCreationParams): Promise<void> {
        await axios.post(BASE_URL, { lastView });
    }

    public static async getEhrList(userId: string): Promise<EhrDataListItem[]> {
        const res = await axios.get(`${BASE_URL}/${userId}/ehr`);

        return res.data;
    }

    public static async getCustomerList(userId: string): Promise<CustomerDataListItem[]> {
        const res = await axios.get(`${BASE_URL}/${userId}/customer`);

        return res.data;
    }
}
